/* WontRip Brand Scripts — SEO/UX Optimized */
(function() {
  'use strict';

  /* Detect reduced motion preference */
  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Add dark body class on homepage */
  if (document.querySelector('[class*="wr-hero"]') || document.querySelector('.wr-categories')) {
    document.body.classList.add('wontrip-dark');
  }

  /* Scroll reveal with IntersectionObserver — INP-optimized */
  function initReveal() {
    var elements = document.querySelectorAll('.wr-reveal');
    if (!elements.length) return;

    /* Skip animations if user prefers reduced motion */
    if (prefersReducedMotion) {
      elements.forEach(function(el) {
        el.classList.add('is-visible');
      });
      return;
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        /* Use requestAnimationFrame to avoid layout thrashing (INP) */
        requestAnimationFrame(function() {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -40px 0px'
      });

      elements.forEach(function(el) {
        observer.observe(el);
      });
    } else {
      /* Fallback: show all immediately */
      elements.forEach(function(el) {
        el.classList.add('is-visible');
      });
    }
  }

  /* Smooth scroll for anchor links — passive-compatible */
  function initSmoothScroll() {
    document.addEventListener('click', function(e) {
      var link = e.target.closest('a[href^="#"]');
      if (!link) return;

      var targetId = link.getAttribute('href');
      if (!targetId || targetId === '#') return;

      var target = document.querySelector(targetId);
      if (!target) return;

      e.preventDefault();
      target.scrollIntoView({
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
        block: 'start'
      });

      /* Update focus for accessibility */
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    }, { passive: false });
  }

  /* ================================================
     UI/UX ENHANCEMENT PACK — 2026-03-08
     ================================================ */

  /* Staggered reveal: auto-assign delay to grid children */
  function initStaggeredReveal() {
    var grids = document.querySelectorAll('.wr-categories__grid, .wr-journey__path, .wr-manifesto__right');
    grids.forEach(function(grid) {
      var items = grid.querySelectorAll('.wr-reveal');
      items.forEach(function(item, i) {
        item.setAttribute('data-reveal-delay', String(Math.min(i, 8)));
      });
    });
  }

  /* Product image zoom — set transform-origin from mouse position */
  function initProductZoom() {
    var zoomContainers = document.querySelectorAll('.wr-product-zoom');
    zoomContainers.forEach(function(container) {
      container.addEventListener('mousemove', function(e) {
        var rect = container.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width * 100).toFixed(1);
        var y = ((e.clientY - rect.top) / rect.height * 100).toFixed(1);
        container.style.setProperty('--zoom-x', x + '%');
        container.style.setProperty('--zoom-y', y + '%');
      }, { passive: true });

      container.addEventListener('mouseleave', function() {
        container.style.setProperty('--zoom-x', '50%');
        container.style.setProperty('--zoom-y', '50%');
      }, { passive: true });
    });
  }

  /* Add-to-cart feedback — event-driven with Shopify cart events */
  function initATCFeedback() {
    /* Track pending buttons for event-driven feedback */
    var pendingBtn = null;
    var feedbackTimeout = null;

    document.addEventListener('click', function(e) {
      var btn = e.target.closest('button[name="add"], .product-form__submit, [data-add-to-cart]');
      if (!btn || btn.classList.contains('is-added') || btn.classList.contains('wr-btn-loading')) return;

      /* Add loading state */
      btn.classList.add('wr-atc-feedback', 'wr-btn-loading');
      pendingBtn = btn;

      /* Safety timeout — if no cart event fires within 5s, reset state */
      feedbackTimeout = setTimeout(function() {
        if (pendingBtn) {
          pendingBtn.classList.remove('wr-btn-loading', 'wr-atc-feedback');
          pendingBtn = null;
        }
      }, 5000);
    });

    /* Listen for Shopify Horizon's native cart events */
    function onCartSuccess() {
      if (!pendingBtn) return;
      clearTimeout(feedbackTimeout);

      pendingBtn.classList.remove('wr-btn-loading');
      pendingBtn.classList.add('is-added');

      var doneBtn = pendingBtn;
      pendingBtn = null;

      setTimeout(function() {
        doneBtn.classList.remove('is-added', 'wr-atc-feedback');
      }, 1500);
    }

    /* Shopify fires multiple possible events depending on theme */
    document.addEventListener('cart:item-added', onCartSuccess);
    document.addEventListener('cart:updated', onCartSuccess);

    /* Also intercept fetch responses to /cart/add.js as fallback */
    if (window.fetch && !window._wr_brand_fetch_wrapped) {
      window._wr_brand_fetch_wrapped = true;
      var originalFetch = window.fetch;
      window.fetch = function() {
        try {
          var args = arguments;
          var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url ? args[0].url : '');

          if (url.indexOf('/cart/add') !== -1) {
            return originalFetch.apply(this, args).then(function(response) {
              if (response.ok) {
                requestAnimationFrame(onCartSuccess);
              }
              return response;
            });
          }
        } catch (e) {
          /* Fallback: pass through on parse error */
        }
        return originalFetch.apply(this, arguments);
      };
    }
  }

  /* Animated stat counter — count from 0 to target on viewport entry */
  function initStatCounters() {
    var stats = document.querySelectorAll('.wr-stat__value');
    if (!stats.length) return;

    if (prefersReducedMotion) return; /* skip if reduced motion */

    var counterObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;

        var el = entry.target;
        var text = el.textContent.trim();

        /* Parse target number and affixes */
        var match = text.match(/^([^\d]*)([\d,. ]+)([^\d]*)$/);
        if (!match) return;

        var prefix = match[1];
        var numStr = match[2].replace(/[\s,]/g, '');
        var suffix = match[3];
        var target = parseFloat(numStr);
        var isFloat = numStr.indexOf('.') !== -1;
        var decimals = isFloat ? (numStr.split('.')[1] || '').length : 0;

        el.setAttribute('data-target', String(target));

        var duration = 1600;
        var start = performance.now();

        function step(now) {
          var elapsed = now - start;
          var progress = Math.min(elapsed / duration, 1);
          /* ease-out cubic */
          var eased = 1 - Math.pow(1 - progress, 3);
          var current = target * eased;

          if (isFloat) {
            el.textContent = prefix + current.toFixed(decimals) + suffix;
          } else {
            el.textContent = prefix + Math.round(current).toLocaleString(document.documentElement.lang || 'en') + suffix;
          }

          if (progress < 1) {
            requestAnimationFrame(step);
          }
        }

        requestAnimationFrame(step);
        counterObserver.unobserve(el);
      });
    }, { threshold: 0.3 });

    stats.forEach(function(stat) {
      counterObserver.observe(stat);
    });
  }

  /* Auto-apply product zoom to main product gallery images */
  function initAutoProductZoom() {
    /* Target Shopify Horizon product media gallery */
    var gallery = document.querySelector('.product-media-gallery, .product__media-list, [class*="product-media"]');
    if (!gallery) return;

    var images = gallery.querySelectorAll('.product-media-gallery__slide, .product__media-item, [class*="product-media__"]');
    images.forEach(function(item) {
      if (!item.classList.contains('wr-product-zoom') && item.querySelector('img')) {
        item.classList.add('wr-product-zoom');
      }
    });
  }

  /* Hero scroll-hint: centered at bottom via CSS only
     Previously aligned to content left edge via JS — removed because it pushed
     the hint off-screen on wide viewports. CSS handles positioning:
     left: 50%; transform: translateX(-50%); bottom: 32px; */
  function initHeroScrollAlign() {
    /* No-op: CSS .wr-hero__scroll-hint handles centering */
  }

  /* Main init function for all enhancements */
  function initEnhancements() {
    initStaggeredReveal();
    initProductZoom();
    initATCFeedback();
    initStatCounters();
    initAutoProductZoom();
    initHeroScrollAlign();
  }

  /* Initialize on DOMContentLoaded or immediately */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initReveal();
      initSmoothScroll();
      initEnhancements();
    });
  } else {
    initReveal();
    initSmoothScroll();
    initEnhancements();
  }

  /* Re-init on Shopify section events (theme editor) */
  document.addEventListener('shopify:section:load', function() {
    requestAnimationFrame(function() {
      initReveal();
      initStaggeredReveal();
      initProductZoom();
      initAutoProductZoom();
      initStatCounters();
      initHeroScrollAlign();
    });
  });
})();


/* === REDESIGN-2026-05-13 T3.1 — Hero kinetic typography === */
(function() {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  function initKinetic() {
    var hero = document.querySelector('.wr-hero__title');
    if (!hero) return;
    var ems = hero.querySelectorAll('em');
    if (ems.length < 2) return;
    if (ems[0].classList.contains('wr-hero__kinetic-strike')) return; // idempotent
    ems[0].classList.add('wr-hero__kinetic-strike');
    ems[1].classList.add('wr-hero__kinetic-type');
    var trigger = function() {
      ems[0].classList.add('is-active');
      setTimeout(function() { ems[1].classList.add('is-active'); }, 1200);
    };
    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function(entries) {
        entries.forEach(function(e) {
          if (e.isIntersecting) { trigger(); obs.disconnect(); }
        });
      }, { threshold: 0.3 });
      obs.observe(hero);
    } else {
      trigger();
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initKinetic);
  } else {
    initKinetic();
  }
})();
/* === /T3.1 kinetic typography === */
